import GlobalSpinner from "@common/GlobalSpinner";
import Header from "@common/layout/Header";
import { checkLoginExpirationTime } from "@utils/authConfig";
import { useEffect } from "react";
import { Outlet, useNavigation } from "react-router-dom";

export default function App() {
  const navigation = useNavigation();
  const isNavigating = Boolean(navigation.location);

  useEffect(() => {
    checkLoginExpirationTime();
  }, []);

  return (
    <div className="flex flex-col h-screen overflow-hidden animate-fadeIn">
      {/* <div className="fixed w-full border-2 border-red-500 top-3 sm:border-pink-500 md:border-green-500 lg:border-blue-500 xl:border-purple-500 2xl:border-cyan-500"></div> */}

      {isNavigating && <GlobalSpinner />}
      <div className="animate-moveFromTop">
        <Header />
      </div>

      <div className="!bg-body h-full overflow-hidden custom-scrollbar p-0 md:p-2 lg:p-3.5">
        <Outlet />
      </div>
    </div>
  );
}
